/* eslint-disable no-underscore-dangle */
const _ = require('lodash');

class PlanStatusRenderer {
  constructor(model) {
    this._model = model;
    this._rootElem = document.createElement('plan-status-column');
    this._rootElem.component = this._model;

    this._registerListeners();
    this.render();
  }

  /** ***************************************** */
  /* START PRIVATE COMPONENT RENDERER METHODS */
  /** ***************************************** */
  _shutdown() {
    const prom = new Promise((resolve /* ,reject */) => {
      this._unregisterListeners();
      this._model = undefined;
      this._rootElem.remove();
      this._rootElem = undefined;
      resolve();
    });
    return prom;
  }

  _registerListeners() {
    this._model.on('PlanStatus', (this._onPlanStatus = this._onPlanStatus.bind(this)));
  }

  _unregisterListeners() {
    this._model.removeAllListeners('PlanStatus');
  }

  /** **************************************** */
  /* END PRIVATE COMPONENT RENDERER METHODS  */
  /* START PUBLIC COMPONENT RENDERER METHODS */
  /** **************************************** */
  /**
   * Stateless method to completely rebuild this component from the _rootElem down.
   * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
   * Promise is returned the caller will assume the Renderer has completed rendering.
   */
  render() {
    const prom = new Promise((resolve /* ,reject */) => {
      this._setPlanStatus(this._model.getValue());
      resolve();
    });
    return prom;
  }

  get rootElement() {
    return this.getRootElement();
  }

  getRootElement() {
    return this._rootElem;
  }

  get model() {
    return this.getModel();
  }

  getModel() {
    return this._model;
  }
  /** **************************************** */
  /* END COMPONENT RENDERER METHODS */
  /* START HANDLER METHODS */
  /** **************************************** */

  _onPlanStatus(newVal) {
    this._setPlanStatus(newVal);
  }

  /** **************************************** */
  /* END HANDLER METHODS */
  /* START PRIVATE API METHODS */
  /** **************************************** */

  _setPlanStatus(newVal) {
    this._rootElem.innerHTML = _.get(this._model._context._planStatusList, newVal, '');
  }

  /** **************************************** */
  /*  END PRIVATE API METHODS */
  /** **************************************** */
}

export default PlanStatusRenderer;
